import { render, staticRenderFns } from "./ProductChip.vue?vue&type=template&id=190a2b2c&scoped=true&"
import script from "./ProductChip.vue?vue&type=script&lang=js&"
export * from "./ProductChip.vue?vue&type=script&lang=js&"
import style0 from "./ProductChip.vue?vue&type=style&index=0&id=190a2b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a2b2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
